export default __webpack_public_path__ + "static/ranwatch-9f27169dff4f6467c2a22dc2e3ec9018.svg";